/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-14 20:26:47
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-15 12:53:53
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ProductsSelection/ProductSelectionWithHsCode/ProductList/index.tsx
 */
import React from 'react';
import css from './css.module.less';
import ProductDisplayInRowLong from 'src/components/DragRowDisplay/ProductDisplayInRowLong1';
import { Spin } from 'antd';
import { Type } from '../index';
import { useHsProductLoading } from './hooks';
const ProductList = (props) => {
  const { data, onDelete } = props;
  const [loading, setLoading] = React.useState(false);
  const { type, products, hsCodes, dangerousGoodsClasses } = data || {};
  const isHs = type === Type.HSCode;
  const isSpecific = type === Type.Specific;
  const [hsProducts, setHsProducts] = React.useState([]);
  useHsProductLoading({
    setHsProducts,
    isHs,
    setLoading,
    hsCodes,
    dangerousGoodsClasses,
  });
  const loopProducts = () => {
    if (isHs) {
      return hsProducts || [];
    }
    if (isSpecific) {
      return products || [];
    }
    return [];
  };

  const handleOnDelete = (index) => {
    if (onDelete) onDelete(index);
  };

  return (
    <div className={css.container}>
      <Spin spinning={loading}>
        {loopProducts().map((i, index, __self) => {
          const { thumbnailUrl, name, sku, productType, remarks } = i;
          return (
            <div
              key={name}
              className={`${css.itemContainer} ${
                index === 0 ? css.itemContainerFirst : ''
              }`}>
              <ProductDisplayInRowLong
                {...(isSpecific
                  ? { onDelete: () => handleOnDelete(index) }
                  : {})}
                name={name}
                sku={sku}
                img={thumbnailUrl}
                type={productType}
                remarks={remarks}
              />
            </div>
          );
        })}
      </Spin>
    </div>
  );
};
export default ProductList;
